import Header from "./components/Header";
import HotGrid from "./components/HotGrid";
import HotRank from "./components/HotRank";
import PersonArchive from "./components/PersonArchive";
import Timeline from "./components/Timeline";
import Gallery from "./components/Gallery";
import Comments from "./components/Comments";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen w-full bg-[rgb(var(--paper))] text-[rgb(var(--ink))]">
      <Header />
      <main>
        <HotGrid />
        <HotRank />
        <PersonArchive />
        <Timeline />
        <Gallery />
        <Comments />
      </main>
      <Footer />
    </div>
  );
}